import { render } from "./add-layout.vue?vue&type=template&id=e28a7dde&ts=true"
import script from "./add-layout.vue?vue&type=script&lang=ts"
export * from "./add-layout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__